module.exports = __webpack_public_path__ + "static/media/snellenDesign.8eefafbb.jpg";